import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

// ----------------------------------------------------------------------------

interface IUser {
  id: string
  email: string
  displayName?: string
  role: string
  avatar?: string
  metadata?: Record<string, unknown>
  [key: string]: unknown
}

interface AuthState {
  token: string | null
  user: IUser | null
}

// ----------------------------------------------------------------------------

const initialState: AuthState = {
  token: null,
  user: null,
}

// ----------------------------------------------------------------------------
// Slice
// ----------------------------------------------------------------------------

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<{ token: string; user: IUser }>) => {
      state.token = action.payload.token
      state.user = action.payload.user
    },
    logout: () => {
      return initialState
    },
  },
})

const { login, logout } = authSlice.actions

export { login, logout }
export type { IUser, AuthState }
export default authSlice.reducer
